import React, { useEffect, useState } from "react"
import { FooterBlock } from "./style"
import { mapColors, mapYears } from "./helper"
import { classNames } from "utils/classNames"
import { useTranslation } from "react-i18next"

const Footer = () => {
  const [years, setYears] = useState([...mapYears])
  const { t } = useTranslation()
  useEffect(() => {
    const currentYear = new Date().getFullYear()
    if (years.indexOf(currentYear) === -1) {
      let newYears = years.slice(1)
      newYears.push(newYears[newYears.length - 1] + 1)
      setYears(newYears)
    }
  }, [])

  return (
    <>
      <FooterBlock className="font-[Roboto] z-[2500] w-full px-4 md:px-6 lg:px-[40px] py-[22px] flex items-center flex-col md:flex-row justify-between gap-2">
        <div className="flex z-[1400] overflow-x-auto w-full pb-2 md:pb-0">
          {years?.map((item, idx) => (
            <div
              key={idx + 1}
              className="flex flex-col items-center justify-center bg-gray-700"
            >
              <div
                className={classNames(mapColors[idx], "w-[50px] h-[20px]")}
              />
              <h2 className="text-xs font-medium text-white">{item}</h2>
            </div>
          ))}
        </div>
        <div className="footer-text w-full flex gap-[8px] ">
          <span>&copy;</span>
          <p>{t("footer-text")}</p>
        </div>
      </FooterBlock>
    </>
  )
}

export default Footer
